module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70518/img/case-study-zero.png"